<template>
  <b-nav-item
    class="mx-2"
    :to="to"
    data-aos="fade-down"
    :data-aos-delay="delay"
    >
    <font-awesome-icon :icon="icon" class="mr-1" />
    <div class="d-inline-block d-md-none d-xl-inline-block">{{title}}</div>
    <div class="d-none d-md-inline-block d-xl-none sr-only">{{title}}</div>
    </b-nav-item>
</template>

<script>
export default {
    props:{
        to: String,
        delay: Number,
        icon: String,
        title: String
    },
  name: "HeaderItem",
};
</script>